import React from 'react';

const GeoJsonMap = React.lazy(() => import('./geoJsonMap'));

export { Map } from './map';
export { GeoJsonMap };
